import StringSimilarity from 'string-similarity';
export const URL = {
  home: {
    hash: '/',
    alias: 'Home',
    id: 'HOME',
  },
  register: {
    hash: '/register',
    alias: 'Register',
    id: 'REGISTER',
  },
  main: {
    hash: '/main',
    alias: 'Main',
    id: 'MAIN',
  },
  academies: {
    hash: '/academias',
    alias: 'Academia',
    id: 'ACADEMIA',
    },
  usuarios: {
      hash: '/usuarios',
      alias: 'Usuario',
      id: 'USUARIO',
  },
  materias: {
    hash: '/materias',
    alias: 'Materia',
    id: 'MATERIA',
  },
  examenes: {
    hash: '/examenes',
    alias: 'Examenes',
    id: 'EXAMENES',
    },
  buscadorpreguntas: {
        hash: '/buscadorpreguntas',
        alias: 'BuscadorPreguntas',
        id: 'BUSCADORPREGUNTAS',
    },
  foros: {
    hash: '/foros',
    alias: 'Foros',
    id: 'FOROS',
  },
  userSetup: {
    hash: '/userSetup',
    alias: 'User Setup',
    id: 'USER_SETUP',
  },
  counter: {
    hash: '/counter',
    alias: 'Counter',
    id: 'Counter',
  },
  file: {
    hash: '/file',
    alias: 'File',
    id: 'FILE',
  },
  realizarExamenRapido: {
    hash: '/realizarExamenRapido',
    alias: 'RealizarExamenRapido',
    id: 'REALIZAR_EXAMEN_RAPIDO',
  },
  realizarExamenReal: {
    hash: '/realizarExamenReal',
    alias: 'RealizarExamenReal',
    id: 'REALIZAR_EXAMEN_REAL',
  },
  realizarExamenSimulacro: {
    hash: '/realizarExamenSimulacro',
    alias: 'RealizarExamenSimulacro',
    id: 'REALIZAR_EXAMEN_SIMULACRO',
  },
  realizarExamenErroneas: {
    hash: '/realizarExamenErroneas',
    alias: 'realizarExamenErroneas',
    id: 'REALIZAR_EXAMEN_ERRONEAS',
  },
  examen: {
    hash: '/examen',
    alias: 'Examen',
    id: 'EXAMEN',
  },
  404: {
    hash: '/404',
    alias: 'Error 404',
    id: '404',
  },
  sessionExpired: {
    hash: '/sesionCaducada',
    alias: 'Sesión Caducada',
    id: 'SESSION_CADUCADA',
  },
  redirectNotFound: {
    hash: '',
    alias: 'Redirección no encontrado',
    id: 'NOT_FOUND',
  },
}

export const getUrl = (key) => {
  let res = '';
  if (key && URL[key]) {
    const urlRes = URL[key].hash;
    const tokkens = urlRes.split('/');
    tokkens.forEach((tokken) => {
      const cnd = tokken.indexOf(':') > -1;
      if (!cnd && tokken) {
        res = `${res}/${tokken}`;
      }
    })
  } else {
    console.warn(`There is no url for: ${key}`);
  }

  return res;
}

export const getCombinedPath = (currentPath, hash) => {
  const interrogationPosition = currentPath.indexOf('?');
  let newCurrentPath = currentPath;
  if (interrogationPosition !== -1) {
    newCurrentPath = currentPath.substr(0, interrogationPosition);
  }
  const hashTokkens = hash.split('/');
  const pathTokkens = newCurrentPath.split('/');
  // solo tengo que combinar si el hash tiene :
  let merge = '';
  hashTokkens.forEach((token, index) => {
    if (token.indexOf(':') > -1 && pathTokkens[index]) {
      merge = `${merge}/${pathTokkens[index]}`;
    } else if (token) {
      merge = `${merge}/${token}`;
    }
  })
  return merge || '/';
}

export const getActualPageName = () => {
  let betterSimilarity = 0;
  let res2return = null;
  const hashValue = window.location.hash.replace('#', '');
  const pageListKeys = Object.keys(URL);
  pageListKeys.forEach((pageKey) => {
    const currentPageProps = URL[pageKey];
    const { hash } = currentPageProps;
    const hashAux = getCombinedPath(hashValue, hash);
    const currentSimilarity = StringSimilarity.compareTwoStrings(hashValue, hashAux);
    if (currentSimilarity > betterSimilarity) {
      betterSimilarity = currentSimilarity;
      const { alias, id } = currentPageProps;
      res2return = { alias, id, hash };
    }
  })

  return res2return;
}
